import { useMediaQuery } from '@material-ui/core';

export const useIsLandscape = () => useMediaQuery('(orientation: landscape)');
